/* tslint:disable */
/* eslint-disable */
/**
 * Customer Journey Endpoints
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

/**
 *
 * @export
 */
export const EasyClaimCaseEventType = {
	Unknown: 'Unknown',
	UsingFrontendByDesktopBrowser: 'UsingFrontendByDesktopBrowser',
	StartCustomerJourney: 'StartCustomerJourney',
} as const;
export type EasyClaimCaseEventType =
	(typeof EasyClaimCaseEventType)[keyof typeof EasyClaimCaseEventType];

export function instanceOfEasyClaimCaseEventType(value: any): boolean {
	for (const key in EasyClaimCaseEventType) {
		if (Object.prototype.hasOwnProperty.call(EasyClaimCaseEventType, key)) {
			if (EasyClaimCaseEventType[key as keyof typeof EasyClaimCaseEventType] === value) {
				return true;
			}
		}
	}
	return false;
}

export function EasyClaimCaseEventTypeFromJSON(json: any): EasyClaimCaseEventType {
	return EasyClaimCaseEventTypeFromJSONTyped(json, false);
}

export function EasyClaimCaseEventTypeFromJSONTyped(
	json: any,
	ignoreDiscriminator: boolean
): EasyClaimCaseEventType {
	return json as EasyClaimCaseEventType;
}

export function EasyClaimCaseEventTypeToJSON(value?: EasyClaimCaseEventType | null): any {
	return value as any;
}

export function EasyClaimCaseEventTypeToJSONTyped(
	value: any,
	ignoreDiscriminator: boolean
): EasyClaimCaseEventType {
	return value as EasyClaimCaseEventType;
}
